export interface ExportColumn {
  key: string;
  title: string;
  render?: (value: any, record: any) => string;
}

export function exportToCSV<T extends Record<string, any>>(
  data: T[],
  columns: ExportColumn[],
  filename: string
): void {
  if (!data.length) return;

  // BOM for UTF-8
  const BOM = '\uFEFF';

  // Build header row
  const headers = columns.map(col => `"${col.title}"`).join(';');

  // Build data rows
  const rows = data.map(record => {
    return columns.map(col => {
      let value: any;

      if (col.render) {
        value = col.render(record[col.key], record);
      } else {
        value = record[col.key];
      }

      // Handle null/undefined
      if (value === null || value === undefined) {
        return '';
      }

      // Convert to string and escape quotes
      const stringValue = String(value).replace(/"/g, '""');
      return `"${stringValue}"`;
    }).join(';');
  });

  const csv = BOM + [headers, ...rows].join('\n');
  downloadFile(csv, `${filename}.csv`, 'text/csv;charset=utf-8');
}

export function exportToJSON<T>(
  data: T[],
  filename: string
): void {
  const json = JSON.stringify(data, null, 2);
  downloadFile(json, `${filename}.json`, 'application/json');
}

function downloadFile(content: string, filename: string, mimeType: string): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

// Format helpers for common export transformations
export const formatDate = (date: string | null | undefined): string => {
  if (!date) return '';
  return new Date(date).toLocaleString('tr-TR');
};

export const formatBoolean = (value: boolean | null | undefined): string => {
  if (value === null || value === undefined) return '';
  return value ? 'Evet' : 'Hayır';
};

export const formatNumber = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '';
  return value.toLocaleString('tr-TR');
};

export const formatCurrency = (value: number | null | undefined, currency = 'TRY'): string => {
  if (value === null || value === undefined) return '';
  return value.toLocaleString('tr-TR', { style: 'currency', currency });
};
